import type { EventBusPayload } from "@/modules/event-bus";

import { useTranslation } from "react-i18next";

import { ONE_MINUTE_IN_SECONDS } from "@/constants/Time";
import { isJobModuleFailedNotificationPayload } from "@/entities/broadcast-notification";
import { useUpdateJobModuleStateQueryData } from "@/entities/job-module";
import { useInvalidateNotifications } from "@/entities/notifications";
import { useAppNotification } from "@/modules/app-notification";
import { useAsyncActions } from "@/modules/async-actions";

import { JobModuleActionLink } from "../job-module-action-link";

export const useJobModuleActionFailed = () => {
  const { t } = useTranslation();
  const { notify } = useAppNotification();
  const { updateJobModuleState } = useUpdateJobModuleStateQueryData();
  const { setFailedState } = useAsyncActions();
  const { invalidateNotifications } = useInvalidateNotifications();

  const runAction = (payload: EventBusPayload) => {
    if (!isJobModuleFailedNotificationPayload(payload)) return;

    notify.error({
      key: payload.id,
      title: t("broadcast:jobModuleFailed", {
        moduleName: payload.job_module.module_name,
      }),
      description: payload.job_module.subjects[0].name,
      descriptionRows: 2,
      actions: (
        <JobModuleActionLink
          subject={payload.job_module.subjects[0]}
          onClick={() => notify.close(payload.id)}
        />
      ),
      duration: ONE_MINUTE_IN_SECONDS,
    });

    setFailedState("jobmodule", payload.job_module.id);
    updateJobModuleState(payload.job_module.id, "Failed");

    invalidateNotifications("*");
  };

  return { runAction };
};
